import { createRouter, createWebHistory } from 'vue-router';

import Dashboard from '@/views/pages/dashboard/dashboard-index.vue';
import LeadsDashboard from '@/views/pages/dashboard/leads-dashboard/leads-dashboard.vue';
import ProspectDashboard from '@/views/pages/dashboard/leads-dashboard/prospect-dashboard.vue';
import StackholderDashboard from '@/views/pages/dashboard/leads-dashboard/stackholder-dashboard.vue';
import ProjectDashboard from '@/views/pages/dashboard/project-dashboard/project-dashboard.vue';
import Login from '@/views/pages/pages/authentication/auth-login.vue';
import Register from '@/views/pages/pages/authentication/auth-register.vue';
import Email_Verification from '@/views/pages/pages/authentication/email-verification.vue';
import Forgot_Password from '@/views/pages/pages/authentication/forgot-password.vue';
import Reset_Password from '@/views/pages/pages/authentication/reset-password.vue';
import Two_Step_Verification from '@/views/pages/pages/authentication/two-step-verification.vue';
import BlankPage from '@/views/pages/pages/blank-page.vue';

import basic_Settings from '@/views/pages/settings/basic-settings/basic-settings.vue';
import Campaign_Settings from '@/views/pages/settings/basic-settings/campaign-settings.vue';
import Category_Settings from '@/views/pages/settings/basic-settings/category-settings.vue';
import Companies_Settings from '@/views/pages/settings/basic-settings/companies-settings.vue';
import Competitor_Settings from '@/views/pages/settings/basic-settings/competitor-settings.vue';
import Country_Settings from '@/views/pages/settings/basic-settings/country-settings.vue';
import Department_Settings from '@/views/pages/settings/basic-settings/departments-settings.vue';
import InfluencingRole_Settings from '@/views/pages/settings/basic-settings/influencing-role-settings.vue';
import Designation_Settings from '@/views/pages/settings/basic-settings/designation-settings.vue';
import District_Settings from '@/views/pages/settings/basic-settings/district-settings.vue';
import Division_Settings from '@/views/pages/settings/basic-settings/division-settings.vue';
import Employee_Settings from '@/views/pages/settings/basic-settings/employee-settings.vue';
import Industry_Settings from '@/views/pages/settings/basic-settings/industry-settings.vue';
import Product_Settings from '@/views/pages/settings/basic-settings/product-settings.vue';
import Profession_Settings from '@/views/pages/settings/basic-settings/profession-settings.vue';
import Role_Settings from '@/views/pages/settings/basic-settings/role-settings.vue';
import Source_Settings from '@/views/pages/settings/basic-settings/source-settings.vue';
import Stage_Settings from '@/views/pages/settings/basic-settings/stage-settings.vue';
import Thana_Settings from '@/views/pages/settings/basic-settings/thana-settings.vue';
import Unit_Settings from '@/views/pages/settings/basic-settings/unit-settings.vue';
import Zone_Settings from '@/views/pages/settings/basic-settings/zone-settings.vue';
import Exhibitions_Settings from '@/views/pages/settings/basic-settings/exhibitions-settings.vue';
import Document_Categories_Settings from '@/views/pages/settings/basic-settings/document-categories-settings.vue';
import RolePermission from '@/views/pages/settings/basic-settings/role-permission.vue';

//leads  Individual
import Ind_Basic_Info from '@/views/pages/leads/individual/basic-info.vue';
import Ind_Initial_Info from '@/views/pages/leads/individual/initial-info.vue';
import Ind_Personal_Info from '@/views/pages/leads/individual/personal-info.vue';
import Ind_Communication_Info from '@/views/pages/leads/individual/communication-info.vue';
import Ind_Service_Info from '@/views/pages/leads/individual/service-info.vue';
import LeadsRouterView from '@/views/pages/leads/leads-router-view.vue';
// Organization
import Org_Concern_Person_Info from '@/views/pages/leads/organization/concern-person-info.vue';
import Org_Initial_Info from '@/views/pages/leads/organization/initial-info.vue';
import LeadsOrgRouterView from '@/views/pages/leads/organization/leads-org-router-view.vue';
import LeadsUpdateOrgRouterView from '@/views/pages/leads/organization/leads-update-org-router-view.vue';

// import LeadsIndexRouterView from '@/views/pages/leads/leads-index-routerview.vue';
import LeadsIndex from '@/views/pages/leads/leads-index.vue';
import LeadsEditRequests from '@/views/pages/leads/leads-edit-requests.vue';
import Org_Initial_Info_update from '@/views/pages/leads/organization/initial-info-update.vue';
import Org_Concern_Person_Info_update from '@/views/pages/leads/organization/concern-person-info-update.vue';
import Org_Lead_Details from '@/views/pages/leads/organization/leads-details.vue';
import KeyAccount_Details from '@/views/pages/keyAccountManage/key-account-details.vue';
import DocumentList from '@/views/pages/documentsManage/document-list.vue';
import KeyAccountList from '@/views/pages/keyAccountManage/key-account-list.vue';
import ProspectList from '@/views/pages/prospects/prospect-list.vue'
import ProspectCreate from '@/views/pages/prospects/create-prospect.vue'
import ProspectUpdate from '@/views/pages/prospects/update-prospect.vue'
import StackholderList from '@/views/pages/stackholders/stackholder-list.vue'
import StackholderCreate from '@/views/pages/stackholders/create-stackholder.vue'
import StackholderUpdate from '@/views/pages/stackholders/update-stackholder.vue'
//Reports
import EmployeeActivity from '@/views/pages/reports/employee-activity.vue'
// Profile update & password change
import ProfileUpdate from '@/views/pages/settings/profile-update/Index.vue'
//sms panel
import SmsRouterView from '@/views/pages/sms/SmsRouter.vue'
import ComposeSMS from '@/views/pages/sms/ComposeSms.vue'
import EmailSettings from '@/views/pages/emailSettings/EmailSettings.vue'
import BirthdayList from '@/views/pages/emailSettings/birthday-list.vue';


const checkToken = async (to, from, next) => {
    const token = localStorage.getItem('bearer_token');
    const tokenExpiration = localStorage.getItem('token_expiration');

    if (!token || token === 'undefined' || token === '') {
        next('/'); // Redirect to login if no token exists
        return;
    }

    if (!tokenExpiration || tokenExpiration === 'undefined') {
        localStorage.removeItem('bearer_token');
        next('/'); // Redirect to login if expiration is missing
        return;
    }

    // Check expiration
    const now = new Date();
    if (new Date(tokenExpiration) < now) {
        console.warn('Token expired');
        localStorage.removeItem('bearer_token');
        localStorage.removeItem('token_expiration');
        next('/'); // Redirect to login if token expired
        return;
    }

    next(); // Proceed to the requested route
};


const activeToken = (to, from, next) => {
  let token = localStorage.getItem('bearer_token');
  if (token === 'undefined' || token === null || token === '') {
      next();
  } else {
      next('/dashboard');
  }
};

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: { title: 'Login  | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' },
    beforeEnter(to, from, next) {
      activeToken(to, from, next);
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: { title: 'Register  | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' },
    beforeEnter(to, from, next) {
      activeToken(to, from, next);
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: Forgot_Password,
    meta: { title: 'Register  | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: Reset_Password,
    meta: { title: 'Forgot Password  | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' },
  },
  {
    path: '/email-verification',
    name: 'email-verification',
    component: Email_Verification,
    meta: { title: 'Email Verification | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/two-step-verification',
    name: 'two-step-verification',
    component: Two_Step_Verification,
    meta: { title: 'Two Step Verification | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/dashboard',
    component: Dashboard,
    children: [
      { path: '', redirect: '/dashboard/leads-dashboard' },
      { path: 'leads-dashboard', component: LeadsDashboard, meta: { title: 'Leads Dashboard | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' } },
      { path: 'prospect-dashboard', component: ProspectDashboard, meta: { title: 'Prospect Dashboard | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' } },
      { path: 'stackholder-dashboard', component: StackholderDashboard, meta: { title: 'Stackholder Dashboard | CRMS - Advanced Bootstrap 5 Admin Template for Customer Management' } }
    ],
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/manage-role-permissions',
    name:'manage-role-permissions',
    component: Role_Settings,
    meta: { title: 'Manage role permissions | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/roles/:roleId/permissions',
    name:'roles/:roleId/permissions',
    component: RolePermission,
    meta: { title: 'Manage role permissions | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/manage-documents',
    name:'manage-documents',
    component: DocumentList,
    meta: { title: 'Manage Documents | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/key-account',
    name:'key-account',
    component: KeyAccountList,
    meta: { title: 'Key Account management | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/key-account/:id/key-account-details',
    name:'key-account-details',
    component: KeyAccount_Details,
    meta: { title: 'Key Account Details | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/prospects',
    name:'prospects',
    component: ProspectList,
    meta: { title: 'Manage Prospects | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/prospect-create',
    name:'prospect-create',
    component: ProspectCreate,
    meta: { title: 'Manage Prospects | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/prospect-update/:id',
    name:'prospect-update',
    component: ProspectUpdate,
    meta: { title: 'Manage Prospects | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/stackholders',
    name:'stackholders',
    component: StackholderList,
    meta: { title: 'Manage Stackholders | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/stackholder-create',
    name:'stackholder-create',
    component: StackholderCreate,
    meta: { title: 'Manage Stackholders | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/stackholder-update/:id',
    name:'stackholder-update',
    component: StackholderUpdate,
    meta: { title: 'Manage Stackholders | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/profile-update',
    name:'profile-update',
    component: ProfileUpdate,
    meta: { title: 'Profile Update | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/reports/employee-activity',
    name:'employee-activity',
    component: EmployeeActivity,
    meta: { title: 'Employee Activity | CRMS' },
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  // {
  //   path: '/employee-tree',
  //   name:'employee-tree',
  //   component: EmployeeTree,
  //   meta: { title: 'Manage Employee category| CRMS' },
  //   beforeEnter(to, from, next) {
  //     checkToken(to, from, next);
  //   }
  // },

  {
    path: '/basic-settings',
    component: basic_Settings,
    children: [
      { path: '', redirect: '/basic-settings/professions' },
      { path: "professions", component: Profession_Settings, meta: { title: 'Professions' } },
      { path: "departments", component: Department_Settings, meta: { title: 'Departments' } },
      { path: "influencing-roles", component: InfluencingRole_Settings, meta: { title: 'Influencing Roles' } },
      { path: "designations", component: Designation_Settings, meta: { title: 'Designations' } },
      { path: "campaigns", component: Campaign_Settings, meta: { title: 'Campaigns' } },
      { path: "industries", component: Industry_Settings, meta: { title: 'Industries' } },
      { path: "lead-stages", component: Stage_Settings, meta: { title: 'Lead-stages' } },
      { path: "competitors", component: Competitor_Settings, meta: { title: 'Competitors' } },
      { path: "companies", component: Companies_Settings, meta: { title: 'Companies' } },
      { path: "sources", component: Source_Settings, meta: { title: 'Information Source Manage' } },
      { path: "countries", component: Country_Settings, meta: { title: 'Countries' } },
      { path: "divisions", component: Division_Settings, meta: { title: 'Divisions' } },
      { path: "districts", component: District_Settings, meta: { title: 'Districts' } },
      { path: "thanas", component: Thana_Settings, meta: { title: 'Thana List' } },
      { path: "zones", component: Zone_Settings, meta: { title: 'Zone List' } },
      // { path: "roles", component: Role_Settings, meta: { title: 'Role List' } },
      { path: "roles/:roleId/permissions", component: RolePermission, meta: { title: 'Role permission' } },
      { path: "employees", component: Employee_Settings, meta: { title: 'Employee List' } },
      { path: "units", component: Unit_Settings, meta: { title: 'Unit List' } },
      { path: "categories", component: Category_Settings, meta: { title: 'Category List' } },
      { path: "products", component: Product_Settings, meta: { title: 'Product List' } },
      { path: "exhibitions", component: Exhibitions_Settings, meta: { title: 'Exhibitions' } },
      { path: "document-categories", component: Document_Categories_Settings, meta: { title: 'Docs Categories' } },
    ],
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/leads-individual',
    component: LeadsRouterView,
    children: [
      { path: '', redirect: '/leads-individual/initial-info' },
      { path: "initial-info", component: Ind_Initial_Info, meta: { title: 'Initial Info | Leads' } },
      { path: "basic-info", component: Ind_Basic_Info, meta: { title: 'Basic Info | Leads' } },
      { path: "personal-info", component: Ind_Personal_Info, meta: { title: 'Personal Info | Leads' } },
      { path: "communication-info", component: Ind_Communication_Info, meta: { title: 'Communication Info | Leads' } },
      { path: "service-info", component: Ind_Service_Info, meta: { title: 'Service Info | Leads' } },
      
    ],
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/leads-organization',
    component: LeadsOrgRouterView,
    children: [
      { path: '', redirect: '/leads-organization/leads-index' },
      { path: "leads-index", component: LeadsIndex, meta: { title: 'List of Leads | Leads' } },
      { path: "leads-edit-requests", component: LeadsEditRequests, meta: { title: 'List of Leads Edit Requests | Leads' } },
      { path: "initial-info", component: Org_Initial_Info, meta: { title: 'Initial Info | Organization' } },
      { path: "concern-person-info", component: Org_Concern_Person_Info, meta: { title: 'Concern person Info | Leads' } },
    ],
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/leads-organization/:id',
    component: LeadsUpdateOrgRouterView,
    children: [
      { path: '', redirect: '/leads-organization/:id/initial-info' },
      { path: "initial-info", component: Org_Initial_Info_update, meta: { title: 'Initial Info Update | Leads' } },
      { path: "concern-person-info", component: Org_Concern_Person_Info_update, meta: { title: 'Concern person Info Update | Leads' } },
      { path: "leads-details", component: Org_Lead_Details, meta: { title: 'Leads Details | Leads' } },
    ],
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
    {
    path: '/sms',
    component: SmsRouterView,
    children: [
      { path: '', redirect: '/sms/compose-sms' },
      { path: "compose-sms", component: ComposeSMS, meta: { title: 'Compose SMS | SMS' } },
    ],
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },

  // {
  //   path: '/email-settings',
  //   name:'email-settings',
  //   component: EmailSettings,
  //   meta: { title: 'Email Settings | CRMS' },
  //   beforeEnter(to, from, next) {
  //     checkToken(to, from, next);
  //   }
  // },
  {
    path: '/birthday-wish',
    name:'birthday-wish',
    component: SmsRouterView,
    children: [
      { path: '', redirect: '/birthday-wish/birthday-list' },
      { path: "birthday-list", component: BirthdayList, meta: { title: 'Birthday List | CRMS' } },
      { path: "email-template-settings", component: EmailSettings, meta: { title: 'Template Settings | CRMS' } },
    ],
    beforeEnter(to, from, next) {
      checkToken(to, from, next);
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'BlankPage',
    component: BlankPage,
  },
 
];

export const router = createRouter({
  history: createWebHistory('/'),
  linkActiveClass: 'active',
  routes,
});


router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'CRMS - Leads Management';
  window.scrollTo({ top: 0, behavior: 'smooth' });
  next();
});